import { render, staticRenderFns } from "./TableColumnsVisibility.vue?vue&type=template&id=83814796&"
import script from "./TableColumnsVisibility.vue?vue&type=script&lang=js&"
export * from "./TableColumnsVisibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports